import { EGI_APP_ROOT, EgiRoutes } from '@ervo/page-framework';
import { Routes } from '@angular/router';
import { LayoutComponent } from '@/app/core/components/layout/layout.component';
import { AppRootPagesModule } from '@/app/egi.pages/app-root.pages/app-root.pages.module';
import { BlockIfNotAuthenticatedGuard } from '@/app/platform/platform-core/user/guards/block-if-not-authenticated.guard';
import { AuthorizationGuard } from '@core/../platform/platform-core/user/guards/authorization.guard';
import { OpenAppGuard } from '@core/guards/open-app.guard';
import { ExternalPagesModule } from '@/app/egi.pages/external.pages/external.pages.module';
import { PlatformManagementPagesModule } from '@/app/egi.pages/platform-management.pages/platform-management.pages.module';
import { CloseListenersGuard } from '@core/guards/close-listeners.guard';
import { ExamplePagesModule } from '@/app/egi.pages/example.pages/example.pages.module';
import { ClearStoresAfterLogoutGuard } from '@core/guards/clear-stores-after-logout.guard';
import { HdPagesModule } from '@/app/egi.pages/human-design/chart.pages/hd.pages.module';
import { HdAppShellComponent } from '@/app/egi.pages/human-design/chart.pages/hd-app-shell/hd-app-shell.component';

export const egiRoutes: EgiRoutes & Routes = [
  {
    path: '',
    component: LayoutComponent,
    data: {
      [EGI_APP_ROOT]: true
    },
    canActivateChild: [
      BlockIfNotAuthenticatedGuard,
      AuthorizationGuard,
      OpenAppGuard,
      CloseListenersGuard,
      ClearStoresAfterLogoutGuard
    ],
    canActivate: [
      BlockIfNotAuthenticatedGuard,
      AuthorizationGuard,
      OpenAppGuard,
      ClearStoresAfterLogoutGuard
    ],
    children: [
      {
        path: 'app',
        children: AppRootPagesModule.routes
      },
      { path: 'admin', children: PlatformManagementPagesModule.routes },
      {
        path: 'external',
        children: ExternalPagesModule.routes
      },
      {
        path: 'examples',
        children: ExamplePagesModule.routes
      },
      {
        // HD-app-shell: host van het app-brede settings-paneel; alle HD-pagina's
        // renderen in zijn router-outlet (spec 2026-09-18-hd-settings-store).
        path: 'human-design',
        component: HdAppShellComponent,
        children: HdPagesModule.routes
      }
    ]
  }
];
